import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  AmazonVanguardPeerLetter,
  AmazonVanguardAdminLetter,
} from '../'
import Styles from './AmazonVanguardLetters.css'

@CSSModules(Styles,{allowMultiple:true})
export default class AmazonVanguardLetters extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    //
    return (
      <div>
        <AmazonVanguardAdminLetter />
        <AmazonVanguardPeerLetter />
      </div>
    )
  }
}
